<template>
  <section v-if="pax && lang['pax_info_new']">
    <Title :title-name="pageTitle" :title-link="title.PassengerDetail.titleLink" />
    <div class="passenger-detail">
      <div class="container">
        <div class="mt-4">
          <ItemOfVouchers icon="contact-detail" color="#a7116f" :label="lang['pax_info_new'].SFS_LANG_ROW_1" border />
        </div>
        <div v-if="getPaxsGroup" class="ws-textbox my-4 d-flex justify-content-between">
          <div class="d-flex justify-content-between w-100">
            <div class="w-50">
              <div v-for="(pax, index) in getPaxsGroup" :key="index + 'fullname'" class="pax-fullname">
                {{ pax.first_name + ' ' + pax.last_name }}
              </div>
            </div>
            <div>
              <div v-for="(pax, index) in getPaxsGroup" :key="index + 'pnr'">PNR: {{ pax.pnr }}</div>
            </div>
          </div>
        </div>
        <div class="my-4">
          <ListFlightInfo :flightLegs="flightLegs" />
        </div>
        <div class="block block-form-confirm">
          <form class="form-horizontal form-content-confirm ws-textbox" @submit.prevent="">
            <div class="pt-2">
              <h5>
                {{ lang['pax_info_new'].SFS_LANG_ROW_2 }}
              </h5>
              <div>
                {{ lang['pax_info_new'].SFS_LANG_ROW_3 }}
              </div>
              <div class="control-group">
                <VueTelInput
                  v-model.trim="phonePax"
                  :class="{ 'validation-failed': !validatePhone }"
                  :placeholder="lang['pax_info_new']?.SFS_LANG_ROW_8 ?? 'Enter phone number'"
                  @input="onInput"
                >
                </VueTelInput>
              </div>
            </div>
            <div class="pt-3 mb-3">
              <h5>
                {{ lang['pax_info_new'].SFS_LANG_ROW_4 }}
              </h5>
              <input
                id="email-address"
                v-model.trim="emailPax"
                type="email"
                class="form-control"
                :placeholder="lang['pax_info_new']?.SFS_LANG_ROW_9 || 'Enter email address'"
              />
            </div>
            <div class="input-group text-center d-block pb-2">
              <button
                type="submit"
                class="ws-btn hd-normal-btn-background-color hd-normal-btn-color"
                :class="classCssCheckConfirm"
                @click="updatePhoneAndEmail()"
              >
                {{ lang['pax_info_new'].SFS_LANG_ROW_5 }}
              </button>
            </div>
          </form>
          <b-modal v-model="isOpenPopup" :modal-class="'ws-modal'" centered hide-footer hide-header @hidden="onClosePopUp()">
            <div class="d-flex justify-content-center align-items-center flex-column py-5">
              <div class="icon-confirm-success">
                <i :class="[message.icon]"></i>
              </div>
              <div class="mt-3 h5">{{ message.text }}</div>
            </div>
          </b-modal>
        </div>
      </div>
    </div>
    <b-alert
      :show="dismissCountDown"
      dismissible
      class="position-fixed fixed-top m-0 rounded-0"
      style="z-index: 2000; border-radius: 1rem !important; border: 1px solid #ffa5a5; color: #444"
      variant="danger"
      @dismissed="dismissCountDown = 0"
    >
      <div>{{ messageAlert }}</div>
    </b-alert>
  </section>
</template>

<script>
import Title from '@/components/Title/index'
import { mapGetters } from 'vuex'
import ItemOfVouchers from '@/components/ItemOfVouchers/index'
import ListFlightInfo from '@/components/ListFlightInfo/index'
import VueTelInput from 'vue-tel-input'

export default {
  name: 'PassengerDetail',
  components: { Title, ItemOfVouchers, ListFlightInfo, VueTelInput },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      curPaxInfo: null,
      phonePaxOrigin: '',
      emailPaxOrigin: '',
      phonePax: '',
      emailPax: '',
      validatePhone: true,
      isOpenPopup: false,
      checkEmail: true,
      tempPhone: '',
      message: {
        icon: '',
        text: ''
      },
      updatePhoneAndMailSuccess: false,
      messageAlert: '',
      dismissCountDown: 0
    }
  },
  computed: {
    ...mapGetters({
      flight: 'Flight/Flight',
      passengersGroup: 'Home/PaxsGroup',
      flightLegs: 'Flight/flightLegs'
    }),
    classCssCheckConfirm() {
      if (this.phonePax === this.phonePaxOrigin && this.emailPax === this.emailPaxOrigin) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.checkEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.emailPax)
        return { avoidClick: true }
      }
      //eslint-disable-next-line
      if (this.emailPax !== null && this.emailPax !== '') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.checkEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.emailPax)
      }
      return this.checkEmail && this.validatePhone ? { '': true } : { avoidClick: true }
    },
    getPaxsGroup() {
      if (this.passengersGroup.length) {
        return _.orderBy(this.passengersGroup, 'pnr')
      }
      return _.orderBy(this.PaxsGroup, 'pnr')
    },
    pageTitle() {
      const { lang } = this
      return lang && lang.pax_info_new && lang.pax_info_new.SFS_LANG_ROW_7 ? lang.pax_info_new.SFS_LANG_ROW_7 : 'Home'
    }
  },
  watch: {
    airline: function () {
      this.initData()
    },
    pax: function () {
      this.initData()
      if (!this.phonePax && !this.emailPax) {
        this.phonePax = this.phonePaxOrigin = this.pax.phone_number
        this.emailPax = this.emailPaxOrigin = this.pax.email_address
      }
    },
    PaxsGroup: function () {
      this.initData()
    }
  },
  created() {
    this.initData()
  },
  mounted() {
    this.$store.dispatch('Flight/getFlight')
  },
  methods: {
    initData() {
      if (!_.isEmpty(this.pax) && !_.isEmpty(this.airline) && !_.isEmpty(this.getPaxsGroup)) {
        // Get current passenger info
        this.curPaxInfo = this.pax
        if (this.getPaxsGroup.length > 1) {
          this.curPaxInfo = _.find(this.getPaxsGroup, { passenger_id: parseInt(this.pax.curPaxID) })
        }
        if (!this.phonePax && !this.emailPax) {
          this.phonePax = this.phonePaxOrigin = this.pax.phone_number
          this.emailPax = this.emailPaxOrigin = this.pax.email_address
          this.clearPhoneNumber()
        }
      }
    },
    onValidate({ isValid }) {
      this.validatePhone = isValid
    },
    onInput(formattedNumber, { number, isValid, country }) {
      setTimeout(() => {
        this.clearPhoneNumber()
      }, 100)
      this.validatePhone = isValid
      if (!formattedNumber) {
        this.validatePhone = true
      }
      this.tempPhone = event.target.value
    },
    clearPhoneNumber() {
      // the second if else use in case the data first load,
      //because the current system automatic include '+' before phone Number
      let addPLusSign = false
      let number = this.phonePax
      if (!number) {
        return
      }
      if (this.hasLeadingPlus(number)) {
        addPLusSign = true
      }
      number = number.replace(/\+/g, '')
      if (this.hasLeadingZeros(number)) {
        addPLusSign = true
        number = number.replace(/^0+/, '')
      }
      if (addPLusSign) {
        number = '+' + number
      }
      this.phonePax = number
    },
    hasLeadingZeros(str) {
      return /^00+/.test(str)
    },
    hasLeadingPlus(str) {
      return /^\++/.test(str)
    },
    onClosePopUp() {
      if (this.updatePhoneAndMailSuccess) {
        this.$router.push({ path: '/home', query: { secret: this.secret } })
      }
    },
    updatePhoneAndEmail() {
      let self = this
      // chỉ cần nhập một trong hai field email hoặc phone, hoặc cả hai
      if (!self.phonePax && !self.emailPax) {
        this.dismissCountDown = 5
        this.messageAlert = 'Please enter your phone number or email address.'
        return
      }
      if (self.phonePax) {
        if (!this.validatePhone) {
          this.dismissCountDown = 5
          this.messageAlert = 'Invalid phone number.'
          return
        }
        if (this.tempPhone) {
          let numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0']
          if (!numbers.includes(this.tempPhone.charAt(this.tempPhone.length - 1))) {
            this.dismissCountDown = 5
            this.messageAlert = 'Invalid phone number.'
            return
          }
        }
      }
      if (self.emailPax && !self.checkEmail) {
        this.dismissCountDown = 5
        this.messageAlert = 'Invalid email address.'
        return
      }

      this.$store
        .dispatch('updatePhoneAndMail', {
          params: {
            phone_number: self.phonePax,
            email: self.emailPax
          }
        })
        .then((res) => {
          if (res.success) {
            this.isOpenPopup = true
            this.phonePaxOrigin = this.phonePax
            this.emailPaxOrigin = this.emailPax
            this.updatePhoneAndMailSuccess = true
            this.$set(this.message, 'icon', 'fas fa-check-circle text-success')
            this.$set(this.message, 'text', this.lang['pax_info_new'].SFS_LANG_ROW_6)
          }
        })
        .catch((error) => {
          this.isOpenPopup = true
          this.updatePhoneAndMailSuccess = false
          this.$set(this.message, 'icon', 'far fa-times-circle danger')
          this.$set(this.message, 'text', 'Fail')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .icon-confirm-success {
  font-size: 20px;
  i {
    font-size: 60px;
  }
}

::v-deep .validation-failed {
  border-color: #ff0000;
  background-color: #ffdddd;
}

.pax-fullname {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
</style>
